import { render, staticRenderFns } from "./SavingsPage.vue?vue&type=template&id=fd9e18ca&scoped=true&"
import script from "./SavingsPage.vue?vue&type=script&lang=js&"
export * from "./SavingsPage.vue?vue&type=script&lang=js&"
import style0 from "./SavingsPage.vue?vue&type=style&index=0&id=fd9e18ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9e18ca",
  null
  
)

export default component.exports